import api from 'Application/api/api';

const deleteUserPhoto = (signal, userEmail) =>
	api.delete(`/users/remove-photo?userEmail=${userEmail}`, {
		signal,
	});

export default deleteUserPhoto;
